import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Wifi(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M21.544 8.73C15.817 3.754 7.281 3.76 1.662 8.724A1 1 0 11.338 7.226c6.381-5.637 16.045-5.63 22.518-.006a1 1 0 01-1.312 1.51zM5.552 12.834c3.665-2.428 8.23-2.428 11.896 0a1 1 0 001.104-1.668c-4.335-2.871-9.77-2.871-14.104 0a1 1 0 101.104 1.668zM11.5 22a1.5 1.5 0 100-3 1.5 1.5 0 000 3zm-2.94-5.171c1.661-1.122 4.219-1.122 5.88 0a1 1 0 101.12-1.658c-2.339-1.578-5.781-1.578-8.12 0a1 1 0 001.12 1.658z",
    clipRule: "evenodd"
  }));
}

export default Wifi;